<template lang="pug">
  div
    el-row(style="display: flex; flex-direction: column")
      el-col(:span="6", style="margin: 15px")
        app-label(label="N° SEI: ", :required="true")
        el-input.input(
          name="N° SEI"
          v-model="numeroSei",
          :class="{'erro' : !model.numerosSei.length && errorView}"
        )
          el-button(
            style="color: #009f61;"
            slot="append",
            icon="el-icon-plus",
            @click="addNumeroSei()",
          )
        div(style="margin-top: 10px;")
          el-tag(
            v-for="(numeroSei, index) in model.numerosSei",
            :key="index",
            closable,
            type="info",
            size="medium",
            style="margin: 5px"
            @close="removeNumeroSei(index)"
        ) {{ numeroSei }}
        span#erro(v-if="!model.numerosSei.length && errorView") Adicione no mínimo um N° SEI
      div(ref="extratoSentenca").container
        el-form(:model="model" label-position="top" label-width="12em")
          vue-form-generator(
            :schema="schema",
            :model="model",
            :options="formOptions"
            ref="form",
            @model-updated="onModelUpdated"
          )
      el-col(:span="6", style="margin: 15px")
        app-label(label="Limites: ", :required="true")
        el-input.input(
          name="Limites"
          v-model="limite",
          :class="{'erro' : !model.limites.length && errorView}"
        )
          el-button(
            style="color: #009f61;"
            slot="append",
            icon="el-icon-plus",
            @click="addLimite()",
          )
        div(style="margin-top: 10px;")
          el-tag(
            v-for="(limite, index) in model.limites",
            :key="index",
            closable,
            type="info",
            size="medium",
            style="margin: 5px"
            @close="removeLimite(index)"
        ) {{ limite }}
        span#erro(v-if="!model.limites.length && errorView") Adicione no mínimo um limite
</template>

<script>

import { mapActions } from 'vuex'
import { component as VueFormGenerator } from 'vue-form-generator'
import AppLabel from '@/components/AppLabel'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import { schemas } from './schemas'

export default {
  components: {
    VueFormGenerator,
    AppLabel
  },

  mixins: [
    AppNotificacao
  ],

  props: {
    despacho: {
      type: Object,
      required: true
    },
    tipo: {
      type: String,
      default: 'NAO_ONEROSO'
    }
  },

  data () {
    return {
      numeroSei: '',
      limite: '',
      model: {
        interessado: {},
        imovel: {},
        numerosSei: [],
        limites: [],
        domicilio: ''
      },
      errorView: false,
      schema: {},
      nomeSchema: '',
      isOutorgadoPessoaFisica: null,
      municipiosListOutorgado: [],
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: true,
        validateBeforeSave: true,
        despacho: null,
        //  tipoModelo 5 corresponde à modelos de registro de imovel
        tipoModelo: 5
      },
      isRepresentantesLegais: false
    }
  },

  async mounted () {
    this.nomeSchema = this.tipo
    this.schema = schemas.emissao_extrato_sentenca[this.tipo]
    this.formOptions.despacho = {
      idProcesso: this.despacho.processo?.id,
      tipo: this.despacho.tipo,
      perfil: this.despacho.perfil
    }
    this.montarExtratoSentenca()
  },

  methods: {
    ...mapActions({
      getInteressado: 'cadastro/getInteressado',
      getImovel: 'cadastro/getImovel'
    }),
    addNumeroSei () {
      if (this.model.numerosSei.includes(this.numeroSei)) {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'Este N° SEI já foi adicionado')
      } else {
        this.model.numerosSei.push(this.numeroSei)
        this.numeroSei = ''
      }
    },
    removeNumeroSei (indexNumeroSei) {
      this.model.numerosSei.splice(indexNumeroSei, 1)
    },
    addLimite () {
      this.model.limites.push(this.limite)
      this.limite = ''
    },
    removeLimite (indexLimite) {
      this.model.limites.splice(indexLimite, 1)
    },
    async montarExtratoSentenca () {
      let model = {...this.model}
      if (this.despacho?.extratoSentenca?.extrato) {
        model = {...this.despacho?.extratoSentenca?.extrato}
      } else {
        model.imovel = (await this.getImovel(this.despacho.processo.numeroProtocolo))[0]
        model.interessado = (await this.getInteressado(this.despacho.processo.numeroProtocolo))[0]
      }
      this.model = model
    },
    save () {
      if (this.formOptions.validateBeforeSave === false || this.validate()) {
        this.errorView = false
        return this.salvarDespacho()
      } else {
        this.errorView = true
        return undefined
      }
    },
    salvarDespacho () {
      let despacho = this.despacho
      despacho.extratoSentenca = {extrato: {...this.model}}
      return despacho
    },
    validate () {
      return this.$refs.form.validate() && this.model.numerosSei.length && this.model.numerosSei.length
    },
    async onModelUpdated (newValue, schema) {}
  }
}
</script>



// WEBPACK FOOTER //
// src/screens/analise/components/AppEmissaoExtratoSentenca.vue